import React, { FC } from 'react';

import './index.scss';

const GoBack: FC<{ onClick: () => void }> = ({ onClick }) => (
  <div className="go-back" onClick={onClick}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M19 12H5"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 19L5 12L12 5"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    Вернуться
  </div>
);

export default GoBack;
